/* eg-oregano-anchor-scroll — the in-page jumps of the Oil of Oregano PDP.

   The CTA buttons point at #ego-offer and the rating line at #ego-reviews.
   A native jump is instant and a native smooth scroll is fast and not tunable,
   so the travel is animated here: slow, eased, and longer the further it has
   to go. Several sections load this file; it binds once for the page.

   Loaded by the sections that carry such a link. */
(function () {
  'use strict';

  if (window.egOreganoAnchorScroll) return;
  window.egOreganoAnchorScroll = true;

  var SELECTOR = 'a[href="#ego-offer"], a[href="#ego-reviews"]';
  var PACE = 1.1; // ms per pixel travelled
  var MIN = 900;
  var MAX = 2600;
  var OFFSET = 16; // a little air above the target

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // slow at both ends, quickest in the middle
  function ease(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function scrollTo(target) {
    var start = window.pageYOffset;
    var end = Math.max(
      0,
      Math.min(
        start + target.getBoundingClientRect().top - OFFSET,
        document.documentElement.scrollHeight - window.innerHeight
      )
    );
    var distance = end - start;
    if (Math.abs(distance) < 2) return;

    if (reduced()) {
      window.scrollTo(0, end);
      return;
    }

    var duration = Math.min(MAX, Math.max(MIN, Math.abs(distance) * PACE));
    var t0 = null;
    var cancelled = false;

    // a touch, a wheel or a key hands control back to the shopper
    var EVENTS = ['wheel', 'touchstart', 'keydown'];

    function stop() {
      cancelled = true;
      release();
    }

    function release() {
      EVENTS.forEach(function (evt) {
        window.removeEventListener(evt, stop);
      });
    }

    EVENTS.forEach(function (evt) {
      window.addEventListener(evt, stop, { passive: true });
    });

    function step(now) {
      if (cancelled) return;
      if (t0 === null) t0 = now;
      var t = Math.min(1, (now - t0) / duration);
      window.scrollTo(0, start + distance * ease(t));
      if (t < 1) requestAnimationFrame(step);
      else release();
    }

    requestAnimationFrame(step);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey) return;

    var target = document.querySelector(link.getAttribute('href'));
    if (!target) return;

    event.preventDefault();
    scrollTo(target);
  });
})();
